import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { DataService } from 'app/shared/services/data/data.service';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';
import { TitleService } from 'app/shared/services/title/title.service';

@Component({
  selector: 'app-licence',
  templateUrl: './licence.component.html',
  styleUrls: ['./licence.component.scss'],
  animations: [
    trigger('divstage', [
      state('slideLeft', style({ transform: 'translateX(0)' })),
      state('slideRight', style({ transform: ' translateX(-100vw)' })),
      transition('slideLeft<=>slideRight', animate('.4s ease-out'))
    ])
  ]
})
export class LicenceComponent implements OnInit {

  pdf: SafeHtml;
  urlPdf: string;
  urlPng: string;
  loading = true;
  responseLicence = false;

  constructor(
    private titleService: TitleService,
    private router: Router,
    private dataService: DataService,
    private ffvService: FfvapiService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.titleService.title.next('Ma licence');
    localStorage.setItem('url', this.router.url);
    this.getLicencePdf();
    this.getLicencePng();
  }

  isMobile(): boolean {
    return this.dataService.isMobile();
  }



  private getLicencePdf(): void {

    this.ffvService.getDetailsUser().subscribe(res => {
      // this.pdf = this.sanitizer.bypassSecurityTrustResourceUrl(res.supporT_PDF);
      this.urlPdf = res.supporT_PDF;

    });


  }
  private getLicencePng(): void {
    this.ffvService.getLicencePng().subscribe(res => {
      let data = 'data:image/png;base64,';
      data += res;
      // this.png = this.sanitizer.bypassSecurityTrustResourceUrl(res.supporT_PDF);
      this.urlPng = data;
      this.loading = false;

      // this.urlPdf = res.supporT_PDF;

      this.responseLicence = res === null ? false : true;


    });

  }

  upLoadMyLicence(): void {
    this.ffvService.getLicencePdf().subscribe(res => {
      const linkSource = 'data:application/pdf;base64,' + res;
      const downloadLink = document.createElement('a');
      const fileName = 'ma_licence.pdf';

      this.pdf = this.sanitizer.bypassSecurityTrustHtml(linkSource);
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();

    });
  }


  dissociate(): void {

    if (localStorage.getItem('url') === 'login') {
      this.router.navigate(['/licence']);
    }
    // this.ngOnInit();
  }

  // link(): void {
  //   this.linkLicence === 'true' ?
  //     this.router.navigate(['/licence']) :
  //     this.router.navigate(['/link-your-account']);

  //   if (this.linkLicence === 'false') {
  //     this.dataService.linkYourAccount.next(true);
  //   }
  // }

}
